import { useState } from 'react';
import { useParams } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import SynthPilotage from '../components/synthesis/SynthPilotage';
import SynthPresentation from '../components/synthesis/SynthPresentation';
import SynthComposition from '../components/synthesis/SynthComposition';
import { SyntheseProvider } from '../components/synthesis/shared/SyntheseContext';

type Sub = 'pilotage' | 'presentation' | 'composition';

export default function ProjectSynthesis() {
  const { id } = useParams<{ id: string }>();
  const [sub, setSub] = useState<Sub>('pilotage');
  if (!id) return null;
  const projectId = Number(id);

  return (
    <SyntheseProvider>
    <div className="synth-wrap">
      <div className="synth-subtabs">
        <button
          className={`synth-subtab ${sub === 'pilotage' ? 'active' : ''}`}
          onClick={() => setSub('pilotage')}
        >
          Pilotage
        </button>
        <button
          className={`synth-subtab ${sub === 'presentation' ? 'active' : ''}`}
          onClick={() => setSub('presentation')}
        >
          Présentation
        </button>
        <button
          className={`synth-subtab ${sub === 'composition' ? 'active' : ''}`}
          onClick={() => setSub('composition')}
        >
          Composition
        </button>
      </div>

      {sub === 'pilotage' && (
        <ErrorBoundary label="le Pilotage">
          <SynthPilotage projectId={projectId} />
        </ErrorBoundary>
      )}
      {sub === 'presentation' && (
        <ErrorBoundary label="la Présentation">
          <SynthPresentation projectId={projectId} />
        </ErrorBoundary>
      )}
      {sub === 'composition' && (
        <ErrorBoundary label="la Composition">
          <SynthComposition projectId={projectId} />
        </ErrorBoundary>
      )}
    </div>
    </SyntheseProvider>
  );
}
